import { Sprout, Leaf, Sparkles, Flower2, Apple, Scissors, Bean } from "lucide-react";

export const STAGE_META = {
  Seed: { icon: Bean, color: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300", ring: "#CA8A04" },
  Germinated: { icon: Sprout, color: "bg-lime-100 text-lime-800 dark:bg-lime-900/40 dark:text-lime-300", ring: "#65A30D" },
  Seedling: { icon: Sprout, color: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300", ring: "#059669" },
  Vegetative: { icon: Leaf, color: "bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300", ring: "#16A34A" },
  Flowering: { icon: Flower2, color: "bg-pink-100 text-pink-800 dark:bg-pink-900/40 dark:text-pink-300", ring: "#DB2777" },
  Fruiting: { icon: Apple, color: "bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-300", ring: "#EA580C" },
  Harvested: { icon: Scissors, color: "bg-stone-200 text-stone-700 dark:bg-stone-700 dark:text-stone-200", ring: "#78716C" },
};

export function stageMeta(stage) {
  return STAGE_META[stage] || { icon: Sparkles, color: "bg-stone-100 text-stone-700", ring: "#78716C" };
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return "—";
  }
}

export function relativeDays(iso) {
  if (!iso) return null;
  const diff = Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
  if (diff === 0) return "today";
  if (diff === 1) return "yesterday";
  if (diff < 0) return `in ${-diff}d`;
  return `${diff}d ago`;
}
